import React from 'react';
import { CatalogFloorPlan } from '@jucy/rentals-api-client/rentals-api-v3/models/CatalogFloorPlan';
import Box from '@mui/material/Box';

export const FloorplanImage: React.FC<{ floorplan: CatalogFloorPlan }> = ({ floorplan }) => (
    <Box component="img" sx={{ width: '100%', height: 'auto' }} src={floorplan.url} alt={floorplan.name} />
);
